module.exports = __webpack_public_path__ + "static/img/icon-lnyos-f2-white.076ba80f.png";